import { QBItemProp, QBType } from '@/components/query-builder/models';
import { TextValueOps } from '@/components/query-builder/text-value';
import { Metafield } from '@/webapi/use-store-settings-api';

export const METAFIELD_TEXT_OPS = [
  TextValueOps.IS,
  TextValueOps.ISNOT,
  TextValueOps.INCLUDES,
  TextValueOps.NOT_INCLUDES,
];

export function buildMetafieldConditions(
  metafields: Metafield[] | undefined,
  envKey: `productMetafield` | `variantMetafield`,
  group: string,
): QBItemProp[] {
  if (!metafields?.length) return [];
  return metafields.flatMap((mf) =>
    (mf.keys || []).map((key) => {
      const metafieldKey = `${mf.namespace}.${key}`;
      return {
        kind: QBType.TEXT_VALUE,
        caption: metafieldKey,
        group,
        envKey,
        metafieldKey,
        placeholder: `type value...`,
        restrictedTextOps: METAFIELD_TEXT_OPS,
        defaultTextValueOp: TextValueOps.IS,
      } as QBItemProp;
    }),
  );
}
